__turbopack_context__.v({
  "contentContainer": "OBrVmW_contentContainer",
  "ctaWrapper": "OBrVmW_ctaWrapper",
  "description": "OBrVmW_description",
  "heading": "OBrVmW_heading",
  "imageWrapper": "OBrVmW_imageWrapper",
  "productImage": "OBrVmW_productImage",
  "section": "OBrVmW_section",
});
